module.exports = __webpack_public_path__ + "static/media/box_real2.eadb91a8.jpg";